module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/69e482d167478834f045fa538d2e7eee.png";